<app-content-container>
  <div class="max-w-5xl mx-auto">
    <h2 class="section-title text-center">Agenda das mentorias</h2>

    <ul
      class="timeline timeline-vertical mt-12"
      data-testid="mentorship-timeline"
      aria-label="Temas das mentorias por mês"
    >
      @for ( theme of themes; track theme.title; let index = $index; let first =
      $first; let last = $last ) {
      <li data-testid="mentorship-timeline-item">
        @if (!first) {
        <hr class="bg-primary/40" aria-hidden="true" />
        }
        <div class="timeline-middle" aria-hidden="true">
          <span class="block rounded-full size-3 bg-primary"></span>
        </div>
        <div
          [class]="
              index % 2 === 0
                ? 'timeline-start info-card mb-6 h-auto p-5'
                : 'timeline-end info-card mb-6 h-auto p-5'
            "
          data-testid="mentorship-card"
        >
          <p
            class="text-xs tracking-wide uppercase text-primary"
            data-testid="mentorship-period"
          >
            {{ theme.month }} {{ theme.year }}
          </p>
          <h3
            class="mt-2 text-base font-semibold text-white"
            data-testid="mentorship-title"
          >
            {{ theme.title }}
          </h3>
        </div>
        @if (!last) {
        <hr class="bg-primary/40" aria-hidden="true" />
        }
      </li>
      }
    </ul>
  </div>
</app-content-container>
